// @flow
import PropTypes from "prop-types";


const HeaderBadge = ({title, danger, light, primary, icon, medium, large, tight, backingBar, image, flash}) => {

    let extraClass="";
    if(danger) {
        if(backingBar) {
            extraClass=" line-behind-red ";
        }
        else {
            extraClass = " li-bg-danger ";
        }
    }
    let iconColor = (danger?"li-fg-danger ":"li-fg-warn-light ");
    if(light) {
        if(backingBar) {
            iconColor="li-fg-slightly-muted ";
        }
        else { // no backer, so apply to the entire bg (bit messed up!)
            extraClass = " li-bg-light ";
        }
    }
    if(primary) {
        extraClass=" li-bg-primary li-fg-white ";
    }
    let noSpace=" px-3 m-3 ";
    if(tight) {
        noSpace=" px-3 m-0 ";
    }
    let backingClass = "";
    if(backingBar) {
        backingClass=" line-behind ";
    }
    let flashClass = "";
    if(flash) {
        flashClass=" li-flash ";
    }
    let fontSizeClass = "li-font-large";
    if(medium) {
        fontSizeClass = "li-font-medium";
    }
    if(large) {
        fontSizeClass = "li-font-huge";
    }

    return(
        <div className={(backingClass+" row rounded "+extraClass+" "+noSpace+flashClass)}>
            <div className="d-flex" style={{marginLeft:"auto",marginRight:"auto",textAlign:"center"}}>
                {icon && <i className={"fa fa-3x mr-2 "+iconColor+icon}/>}
                {image && <img src={image} className={"li-header-badge-image align-self-center "+(danger?"danger":"")} alt="header badge"/>}
                <div className={"d-inline font-weight-bold align-self-center "+fontSizeClass}>{title}</div>
            </div>
        </div>
    );
}

HeaderBadge.propTypes = {
    title: PropTypes.string.isRequired,
    danger: PropTypes.bool,
    light: PropTypes.bool,
    primary: PropTypes.bool,
    icon: PropTypes.string,
    medium: PropTypes.bool,
    tight: PropTypes.bool,
    backingBar: PropTypes.bool,
    image: PropTypes.string,
    flash: PropTypes.bool
}

export default HeaderBadge;